import * as dat from 'dat.gui'

import { TweenLite } from 'gsap/TweenLite'

export default class ThreejsJourney
{
    constructor(_options)
    {
        this.config = _options.config
        this.time = _options.time
        this.world = _options.world

        this.$container = document.querySelector('.js-threejs-journey')
        this.$messages = [...this.$container.querySelectorAll('.js-message')]
        this.$yes = this.$container.querySelector('.js-yes')
        this.$no = this.$container.querySelector('.js-no')
        this.step = 0
        this.maxStep = this.$messages.length - 1
        this.seenCount = window.localStorage.getItem('seenCount') || 0
        this.seenCount = parseInt(this.seenCount)
        this.shown = false
        this.traveledDistance = 0
        this.minTraveledDistance = 25 //行驶最小25个单位时打开弹框 (this.config.debug ? 5 : 75) * (this.seenCount + 1)
        this.prevent = !!window.localStorage.getItem('prevent')
        // if(this.config.debug)
        //     this.start()

        if(this.prevent)
            return

        this.setYesNo()
        this.setLog()

        this.time.on('tick', () =>
        {
            if(this.world.physics)
            {

                this.traveledDistance += this.world.physics.car.forwardSpeed
                //现在允许移动端弹框了
                //PC端计算距离25弹框，移动端25-7.5
                if((!this.config.touch && !this.shown && this.traveledDistance > this.minTraveledDistance)||
                (this.config.touch && !this.shown && this.traveledDistance > this.minTraveledDistance - 7.5))
                {
                    this.openDebug()
                    this.start()
                }
            }
        })
    }

    openDebug()
    {

    }

    setYesNo()
    {
        this.$yes.addEventListener('click', () =>
        {
            TweenLite.delayedCall(2, () =>
            {
                this.hide()
            })
            window.localStorage.setItem('prevent', 1)
        })

        this.$no.addEventListener('click', () =>
        {
            this.next()

            TweenLite.delayedCall(5, () =>
            {
                this.hide()
            })
        })

        this.$yes.addEventListener('mouseenter', () =>
        {
            this.$container.classList.remove('is-hover-none')
            this.$container.classList.remove('is-hover-no')
            this.$container.classList.add('is-hover-yes')
        })

        this.$no.addEventListener('mouseenter', () =>
        {
            this.$container.classList.remove('is-hover-none')
            this.$container.classList.add('is-hover-no')
            this.$container.classList.remove('is-hover-yes')
        })

        this.$yes.addEventListener('mouseleave', () =>
        {
            this.$container.classList.add('is-hover-none')
            this.$container.classList.remove('is-hover-no')
            this.$container.classList.remove('is-hover-yes')
        })

        this.$no.addEventListener('mouseleave', () =>
        {
            this.$container.classList.add('is-hover-none')
            this.$container.classList.remove('is-hover-no')
            this.$container.classList.remove('is-hover-yes')
        })
    }

    setLog()
    {

    }

    hide()
    {
        for(const _$message of this.$messages)
        {
            _$message.classList.remove('is-visible')
        }

        TweenLite.delayedCall(0.5, () =>
        {
            this.$container.classList.remove('is-active')
        })
    }

    start()
    {
        this.$container.classList.add('is-active')
        window.requestAnimationFrame(() =>
        {
            this.next()

            TweenLite.delayedCall(4, () =>
            {
                this.next()
            })
            TweenLite.delayedCall(7, () =>
            {
                this.next()
            })
        })

        this.shown = true
        window.localStorage.setItem('seenCount', this.seenCount + 1)
    }

    updateMessages()
    {
        let i = 0
        for(const _$message of this.$messages)
        {
            if(i < this.step)
                _$message.classList.add('is-visible')
            i++
        }

        this.$messages.reverse()
        let height = 0
        i = this.maxStep
        for(const _$message of this.$messages)
        {
            const messageHeight = _$message.offsetHeight
            if(i < this.step)
            {
                _$message.style.transform = `translateY(${- height}px)`
                height += messageHeight + 20
            }
            else
            {
                _$message.style.transform = `translateY(${messageHeight}px)`
            }
            i--
        }
        this.$messages.reverse()
    }

    next()
    {
        if(this.step > this.maxStep)
            return
        this.step++
        this.updateMessages()
    }
}
